var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"shop",style:(_vm.christmasFideliteTcl)},[(!_vm.$vuetify.breakpoint.xsOnly)?_c('PageTitle',{staticClass:"shop-title",attrs:{"text":"Boutique","hideIcon":""}}):_vm._e(),(!_vm.$vuetify.breakpoint.xsOnly)?_c('ShopSlider'):_vm._e(),_c('ShopOffers',{attrs:{"searchEvent":_vm.searchEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }